import { PhotoTextZoneConfig } from '../../global-types';
import colorsList from '../../styles/util.scss';

export const photoTextZoneConfig: PhotoTextZoneConfig = {
  photoTextZoneDefaultSettings: {
    fill: 'transparent',
    stroke: colorsList['medium-gray'],
    strokeDashArray: [5],
    strokeWidth: 1,
    // PRCM-10897: 4px rounded corners per Figma spec so the placeholder
    // outline matches the active-editing overlay-textarea border-radius.
    rx: 4,
    ry: 4,
    // PRCM-10897: the visible dashed outline comes from `stroke` above; we
    // never want fabric's selection border on top of it (thicker, denser,
    // square-cornered). Default to false so every code path — create, load,
    // and any future consumer — gets the right behavior.
    hasBorders: false,
    hasControls: false,
    hoverCursor: 'pointer',
    isModified: false,
    lockMovementX: true,
    lockMovementY: true,
    lockRotation: true,
    lockScalingFlip: true,
    lockSkewingX: true,
    padding: -2,
    selectable: true,
    paintFirst: 'stroke',
    evented: true,
    hasRotatingPoint: false,
  },
  // arbitrary value used to space the buttons in phototextzones
  buttonOffsetX: 125,
  buttonOffsetY: 60,
  resetButtonOffset: 50,
};
